import { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

export const RequirePermission = ({
  children,
  permission,
  redirectTo = '/',
}: {
  children: JSX.Element;
  permission: string;
  redirectTo?: string;
}) => {
  const auth = useAuth();

  if (!auth.isInitialised) {
    return null;
  }

  const allowed = !!auth.user?.role?.[permission];
  return allowed ? children : <Navigate to={redirectTo} replace state={{ accessDenied: true }} />;
};
